var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 10 4 6h8l-4 4z","fill":"#A3A1A7"}));
}

ArrowDown.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
